import gql from 'graphql-tag';

const UPDATE_CLASSROOM_SETTING_FRAGMENT = gql`
  fragment UpdateClassroomSettingFragment on BaseClassroomSettingResponse {
    classroom {
      id
    }
    app {
      id
      name
    }
    setting
    value
  }
`;

export default UPDATE_CLASSROOM_SETTING_FRAGMENT;
